import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface MarkdownRendererProps {
    content: string;
    className?: string;
}

export function MarkdownRenderer({ content, className }: MarkdownRendererProps) {
    return (
        <div className={`prose prose-sm prose-invert max-w-none break-words ${className ?? ''}`}>
        <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            disallowedElements={['script', 'style', 'iframe', 'object', 'embed', 'form', 'input']}
            unwrapDisallowed
            skipHtml
            components={{
                a: ({ href, children }) => (
                    <a
                        href={href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-violet-400 hover:underline"
                    >
                        {children}
                    </a>
                ),
                img: ({ src, alt }) => (
                    <img
                        src={src}
                        alt={alt ?? ''}
                        className="max-h-64 rounded-md"
                        loading="lazy"
                    />
                ),
            }}
        >
            {content}
        </ReactMarkdown>
        </div>
    );
}
